import { patch } from '@mui/material';
import AthenaParameterTransformation from '../utils/AthenaParameterTransformation';
import LambdaFetch from './FetchFromLambda';

export default async function fetchFromAthena (params) {
    const {queryName, headers, pageSize = 9999, accessToken, credentials} = params;
  try {
    const parameters = AthenaParameterTransformation(queryName, headers)

    if(!parameters) {
      console.log("Query doesn't exist")
      return []
    }
    
    // const fetchBody = {
    //   dashboard_name: queryName,
    //   ...parameters,
    //   pageSize: pageSize,
    //   roles: credentials.user.roles,
    //   frontendTable: true
    // }
    // const resp = await LambdaFetch(
    //   'dashboard-trigger-temp-table',
    //   'post',
    //   accessToken,
    //   JSON.stringify(fetchBody),
    //   '',
    //   credentials
    // )
    // return resp.data.response.data === '[]' ? [] : resp.data.response.data


    const resp = await LambdaFetch(
            'athena/execute',
            'post',
            credentials.user.accessToken,
            JSON.stringify({
              reportName: queryName,
              variables: { ...parameters }
            }),
            '',
            credentials
          )
    
    return resp.data
  } catch (e) {
    console.log(e)
    return false
  }
}
